import promise from 'redux-promise';
import thunk from 'redux-thunk';

export const middlewares = [
  thunk,
  promise,
];
